// router/index.js
import { createRouter, createWebHistory } from 'vue-router';


const routes = [
    {
        // Add other routes here
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
